import { ConnectedCase } from "app/area/bowtie/types-store";
import { Value } from "app/types-shared";

const groupByKey = <T>(
  connected: ConnectedCase[],
  valueExtractor: (curr: ConnectedCase) => T
): Record<number, T[]> => {
  return connected.reduce((acc, curr) => {
    const key = (curr.fields.ConnectedConnectionType as Value).v;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(valueExtractor(curr));
    return acc;
  }, {} as Record<number, T[]>);
};

export const groupConnectedCasesByConnectionType = (connected: ConnectedCase[]) => {
  return groupByKey(connected, (curr) => curr.caseId);
};

export const groupConnectedCases = (connected: ConnectedCase[]) => {
  return groupByKey(connected, (curr) => curr);
};
